import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import PropTypes from "prop-types";

export default function Award({ url, index, gotAward, name, hours }) {
  const style = useMemo(
    () => ({
      opacity: gotAward ? 1 : 0.3,
      transition: `all ${!gotAward ? 0.1 : 2 * (index + 1)}s`,
      filter: `grayscale(${!gotAward ? 1 : 0})`,
    }),
    [gotAward, index]
  );

  return (
    <Box my={1} key={url ? url.split("/").pop() : index} mr={3} alignItems="center" display="flex" flexDirection="column">
      <img height="50" src={url} alt={url ? url.split("/").pop() : "Award"} style={style} />
      <Typography align="center" sx={{ ...style, fontWeight: 700, fontSize: 14, lineHeight: "16px" }}>
        {name}
      </Typography>
      {hours && (
        <Typography align="center" sx={{ ...style, fontWeight: 700, fontSize: 12, lineHeight: "14px" }}>
          {hours}+ hours
        </Typography>
      )}
    </Box>
  );
}

Award.defaultProps = {
  url: "",
  index: 0,
  gotAward: false,
  name: "",
  hours: 0,
};

Award.propTypes = {
  url: PropTypes.string,
  index: PropTypes.number,
  gotAward: PropTypes.bool,
  name: PropTypes.string,
  hours: PropTypes.number,
};
